import React from 'react';

export default function NotFoundPage() {
  return (
    <h1>
      Oh dear, something went wrong.
    </h1>
  );
}
